module.exports = __webpack_public_path__ + "img/2.85bf4127.webp";